import { DomainDomainValueT } from "@/service/orion";

import { IPowerBIDashboard } from "../models/IPowerBIDashboard";

export const domainValueToPowerBIDashbord = (
  domainValue: DomainDomainValueT,
): IPowerBIDashboard => {
  try {
    const params = JSON.parse(domainValue.description || "{}");

    if (!params.reportId || !params.groupId) {
      throw new Error(`Dashboard PowerBi ${domainValue.value} no configurado correctamente`);
    }

    return {
      code: domainValue.code,
      name: domainValue.value,
      reportId: params.reportId,
      groupId: params.groupId,
    };
  } catch (error) {
    throw new Error(`Dashboard PowerBi ${domainValue.value} no configurado correctamente`);
  }
};
